import api from '@/utils/api';

const state = {
    statementOptions: [],
    statementUiOptions: [],
};

const getters = {
    // api 原始資料
    statementOptions: (state) => state.statementOptions,

    // 為了符合 ui 元件欄位：移除leaf的childSettings(只有兩層)
    statementUiOptions: (state) => state.statementUiOptions,
};

const actions = {
    updateStatementOptions({ commit }) {
        return new Promise((resolve, reject) => {
            api({ url: 'Tool/GetIncomeStatementSettings', data: null, method: 'GET' })
                .then((resp) => {
                    commit('update_statementOptions', resp.data);
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    update_statementOptions(state, options) {
        state.statementOptions = options;

        state.statementUiOptions = JSON.parse(JSON.stringify(options));
        for (const type in state.statementUiOptions) {
            // 第一層 (ex:系統預設)
            for (let i = 0; i < state.statementUiOptions[type].length; i++) {
                // 第二層 (ex: 匯費)
                for (let j = 0; j < state.statementUiOptions[type][i].childSettings.length; j++) {
                    if (state.statementUiOptions[type][i].childSettings[j].childSettings.length == 0) delete state.statementUiOptions[type][i].childSettings[j].childSettings;
                }
            }
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
